import { render, staticRenderFns } from "./largebox.vue?vue&type=template&id=3e079bcb&scoped=true"
import script from "./largebox.vue?vue&type=script&lang=js"
export * from "./largebox.vue?vue&type=script&lang=js"
import style0 from "./largebox.vue?vue&type=style&index=0&id=3e079bcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e079bcb",
  null
  
)

export default component.exports